import { useQuery } from "@apollo/client";
import { CenterResult } from "__legacy/components/CenterResult";
import { CenterSpinner } from "__legacy/components/CenterSpinner";
import { loader } from "graphql.macro";
import { Fragment, ReactElement, ReactNode } from "react";

import {
  ActivityStageQuery as ActivityStageQueryType,
  ActivityStageQueryVariables,
} from "./__generated__/ActivityStageQuery";

const ActivityStageQuery = loader("./ActivityStageQuery.gql");

type ActivityStageQueryProviderType = (props: {
  children: (data: ActivityStageQueryType) => ReactNode;
  variables: ActivityStageQueryVariables;
}) => ReactElement;

export const ActivityStageQueryProvider: ActivityStageQueryProviderType = (props) => {
  const { children, variables } = props;

  const { error, loading, data } = useQuery<ActivityStageQueryType, ActivityStageQueryVariables>(ActivityStageQuery, {
    variables,
    fetchPolicy: "cache-and-network",
  });

  if (loading) return <CenterSpinner size="large" />;
  if (error || !data)
    return <CenterResult status="404" title="404" subTitle="Sorry, the page you visited does not exist." />;

  return <Fragment>{children(data)}</Fragment>;
};
